import { NonNullableSettingConfig } from "./NonNullableSettingConfig";

export class ArraySetting<T> implements NonNullableSettingConfig<Array<T>> {
  type = "array" as const;

  serialize(value: Array<T>): string {
    return JSON.stringify(value);
  }

  deserialize(value: string): Array<T> {
    return JSON.parse(value);
  }
}
